module.exports = __webpack_public_path__ + "static/media/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-03.3c07d2ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/documents/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-03.jpg
// module id = 879
// module chunks = 0